  <script>
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition';
  import { Card, CardBody, CardFooter, CardHeader, Pagination, PaginationItem, PaginationLink, Table, } from 'sveltestrap';
  import Search from '../components/Search.svelte';
  import http from '../api/http.js';
  import { selectedGroup, currentPage, userSettings, branding } from '../store.js';
  import { Link } from 'svelte-routing';  
  import TableColumn from '../components/TableColumn.svelte';
  import Tooltip from '../reusable components/tooltip.svelte';
  import ManageVesselAttributesModal from '../modals/ManageVesselAttributesModal.svelte';

  var searchTerm = "";
  let vessels = [];
  let selectedVessels = [];
  let pageNumber = 1;
  let totalPageCount = 0;
  let totalVesselCount = 0;
  let inputLength = 0;
  let searchRefresh = false;
  let showAttributes = false;
  let uniqueAttributeNames = [];
  let manageVesselAttributeModal;
  let allVesselsSelected = false;
  let previousPageNumber = 0;
  let computers = [];
  let kioskTooltipContent = [];
  const awaitingKioskTooltip = [
    {
      "name": "",
      "icon": "desktop",
      "iconType": "fad",
      "value": "loading...",
      "color": "black"
    },
  ]

  const displayNumbers = [10, 25, 50, 100, 200]

  let displayNumber = displayNumbers[0];

  let sortType = {
    ascending: 'ascending',
    descending: 'descending',
    resting: 'resting'
  }

  let activeColumn = {
    columnValue: 0,
    sortType: sortType.ascending,
  };

  function toggleSort(columnValue, theSortType){
    if(activeColumn.value != columnValue){
      activeColumn.columnValue = columnValue;
    }
    switch(theSortType){
      case sortType.resting:
        activeColumn.sortType = sortType.ascending;
        break;
      case sortType.ascending:
        activeColumn.sortType = sortType.descending;
        break;
      case sortType.descending:
        activeColumn.sortType = sortType.ascending;
        break;
    }
    
    if(activeColumn.sortType != sortType.resting){
      loadVessels(activeColumn.columnValue, activeColumn.sortType);
    }
    else{
      activeColumn.columnValue = 0;
      activeColumn.sortType = sortType.ascending;
      loadVessels(0, activeColumn.sortType);
    }
  }

  $:activeColumn;

  const toggleAttributes = () => (showAttributes = !showAttributes);

  $: {    
      $selectedGroup;
      if ($selectedGroup != undefined){
        loadVessels(activeColumn.columnValue, activeColumn.sortType);
        getUniqueAttributeNames();
      }  
    }

  $: {    
    displayNumber;
    loadVessels(activeColumn.columnValue, activeColumn.sortType);
  } 

  $: {    
    loadVessels(activeColumn.columnValue, activeColumn.sortType);
    if (previousPageNumber != pageNumber) {
      allVesselsSelected = false;
      previousPageNumber = pageNumber;
    }
  }

  async function getUniqueAttributeNames(){
    try {  
      const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/names/${$selectedGroup}`);
      uniqueAttributeNames = await res.json();        
      
    } catch (error) {
      uniqueAttributeNames = [];
    }
  }

  function getAttributeValue(vessel, uniqueAttribute){
    var attribute = vessel.attributes.filter(attr => attr.name == uniqueAttribute)
    if(attribute.length > 0){
      return attribute;
    }else{
      return "";
    }    
  }

  async function loadVesselsAndAttributes(){
    await loadVessels(activeColumn.columnValue, activeColumn.sortType);
    await getUniqueAttributeNames();
    selectedVessels.forEach(vessel => {
      vessel.selected = false;
    });
    selectedVessels = [];
    selectedVessels = selectedVessels;
    vessels.forEach(vessel => {
      vessel.selected = false;
    })
    vessels = vessels;
  }
  
  async function loadVessels(columnValue, sortTypeArg){
    if({$selectedGroup} != undefined){
      let ascending = sortTypeArg == sortType.ascending ? true : false;
      var url;
      if(activeColumn.sortType == undefined){
        activeColumn.sortType = sortType.resting;
      }
      if(columnValue == undefined){
         columnValue = 0;
      }
      if(ascending == undefined){
         ascending = true;
      }
      if(searchTerm.length > 0 && searchTerm != ""){
        url = `/deploy/dashboard/vessels/${$selectedGroup}/${searchTerm.toLocaleLowerCase()}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}/true`;         
      }
      else{
        url = `/deploy/dashboard/vessels/${$selectedGroup}/${displayNumber}/${pageNumber}/${columnValue}/${ascending}/true`;        
      }
      const res = await http.get(window.apiBaseUrl + url);
      if(res.status == 200)
      {
        var uiVesselCollection = await res.json();
        vessels = uiVesselCollection.vessels;
        totalPageCount = uiVesselCollection.totalPageCount;
        totalVesselCount = uiVesselCollection.noPaginationVesselCount;        
        checkStoredVessels();
      }
    }    
  }

  function setPageNumber(number){
    pageNumber = number;    
  }

   async function searchVessels(){ 
    searchRefresh = true;    
    let interval = setInterval( async () => {
      if(searchTerm.length != inputLength){
        pageNumber = 1;
        loadVessels(activeColumn.columnValue, activeColumn.sortType);   
      }   
      if(!searchRefresh){
        clearInterval(interval);
      }
      inputLength = searchTerm.length;      
    }, 2000);    
  }

   function toggleSelectAllVessels(){
    if(allVesselsSelected){
      vessels.forEach(vessel => {
        vessel.selected = true;
        if(!selectedVessels.map(v => v.id).includes(vessel.id)){
          selectedVessels.push(vessel);
        }
      });
    }
    else{
        vessels.forEach(vessel => {
        vessel.selected = false;
        selectedVessels = selectedVessels.filter(v => v.id != vessel.id);
      });
    }
    vessels = vessels;
    selectedVessels = selectedVessels;
  }

  function selectVessel(vessel){
    if(vessel.selected){
      selectedVessels.push(vessel);
    }
    else{
      selectedVessels = selectedVessels.filter(v => v.id != vessel.id);
    }
    selectedVessels = selectedVessels;
    vessels = vessels;
  }

  function checkStoredVessels(){
    vessels.forEach(vessel => {
      if(selectedVessels.map(v => v.id).includes(vessel.id)){
        vessel.selected = true;
      }
    });
  }

  onMount(async () => {      
    currentPage.set('vessels');
  });
  
  function vesselTooltipContent(vessel){
    let tooltip = {
      "name": "",
      "icon": "desktop",
      "iconType": "fad",
      "value": "",
      "color": "danger"
    };
    kioskTooltipContent = [];
    vessel.duplicateKiosks.forEach(kiosk => {
      tooltip.value = kiosk;
      kioskTooltipContent.push({...tooltip});
    });
    
    kioskTooltipContent = kioskTooltipContent;
    return kioskTooltipContent;
  }

</script>
  <Card class="shadow mb-4">
    <CardHeader>
      <div class="d-flex row">
        <h4 class="mt-1 ml-1 font-weight-bold text-primary"><i class="fas fa-ship"></i> Vessels</h4>
        <div class="ml-4">
          <div class="input-group mb-3">           
            <Search id="vessels-search-input" bind:searchTerm on:focusout={() => searchRefresh =  false} on:input={() => searchVessels()} placeholder="Search Vessels..."></Search>      
          </div>
        </div>          
        <div class="viewButton d-flex" >
          <button id="manage-vessel-attributes-button" class="btn btn-link" on:click={() => manageVesselAttributeModal.show(selectedVessels, searchTerm)}>Manage Attributes</button>
        </div>
      </div>
    </CardHeader>
    <CardBody>
      <Table responsive>
        <thead>
          <tr>
            <th><input class="mr-2" type="checkbox" bind:checked={allVesselsSelected} on:change={() => toggleSelectAllVessels()}/>{selectedVessels.length > 0 ? `(${selectedVessels.length})` : ""}</th>        
            <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} sortType={activeColumn.sortType} active={activeColumn.columnValue == 0}>Account Name</TableColumn>
            <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} sortType={activeColumn.sortType} active={activeColumn.columnValue == 1}>Vessel Name</TableColumn>
            {#if showAttributes == false}
              <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} sortType={activeColumn.sortType} active={activeColumn.columnValue == 4}>Subscription Level</TableColumn>
              <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} sortType={activeColumn.sortType} active={activeColumn.columnValue == 5}>Group</TableColumn>
              <TableColumn on:mousedown={() => toggleSort(6, activeColumn.sortType)} sortType={activeColumn.sortType} active={activeColumn.columnValue == 6}>Computers</TableColumn>
            {/if}
            <th id="toggle-vessel-attributes-button" on:mousedown={() => toggleAttributes()}>Attributes  <i class="fa {showAttributes === true ? 'fa-caret-left' : 'fa-caret-right'} toggle"></i></th>
            {#if showAttributes}
              {#each uniqueAttributeNames as uniqueAttributeName}
                  <th>{uniqueAttributeName}</th>
              {/each}
            {/if}  
          </tr>          
        </thead>    
        <tbody>
          {#each vessels as vessel}            
            <tr id="vessel-row-{vessel.name}">
                <td><input id="vessel-checkbox-{vessel.id}" type="checkbox" bind:checked={vessel.selected} on:change={() => selectVessel(vessel)}/></td>
                <td class="vesselRow">
                  {#if vessel.hasDuplicateKiosks}
                    <Tooltip content={vesselTooltipContent(vessel)} legend={true} title={"Duplicate Kiosks"}>
                      <i class="fad fa-exclamation-triangle fa-sm font-weight-normal text-danger"></i>
                    </Tooltip>
                  {/if}
                  <Link to="/vessel/{vessel.id}">{vessel.account}</Link>
                </td>
                <td>{vessel.name}</td>
                {#if showAttributes == false}
                  <td>{vessel.subscriptionLevel}</td>
                  <td>{vessel.group}</td>
                  <td>{vessel.computerCount}</td>
                {/if}
                <td>{vessel.attributeCount}</td>
                  {#if showAttributes}
                      {#each uniqueAttributeNames as uniqueAttribute}                            
                        {#if vessel.attributes.filter(attr => attr.name == uniqueAttribute)}
                          <td>
                            {#each getAttributeValue(vessel, uniqueAttribute) as attribute}
                              {attribute.value}<br>
                            {/each}
                          </td>
                      {:else}
                        <td></td>
                    {/if}    
                  {/each}        
              {/if}
            </tr>            
          {/each}
        </tbody> 
      </Table>  
    </CardBody>
    <CardFooter>
      <div class="pagination bg-light shadow-none ml-0 d-flex">
        <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalVesselCount ? totalVesselCount:pageNumber * displayNumber)} of {totalVesselCount} vessels</small>
        <div class="mt-2 justify-content-center">

          <Pagination>
            <PaginationItem disabled={pageNumber == 1}>
              <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
            </PaginationItem>

            <PaginationItem  disabled={pageNumber == 1}>
              <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
            </PaginationItem>

            {#if totalPageCount > 5}
              {#each Array(5) as _, count}
                {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                  <PaginationItem active={pageNumber == count + pageNumber} >
                    <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber <= 3}
                  <PaginationItem active={pageNumber == count + 1} >
                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber >= totalPageCount - 2}
                  <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                    <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                  </PaginationItem>
                {/if}
              {/each}
            {:else}
              {#each Array(totalPageCount) as _, count}
                <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                  <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                </PaginationItem>
              {/each}
            {/if}      

            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
            </PaginationItem>
            
            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
            </PaginationItem>
          </Pagination>
          
        </div>
        <div class="mt-2 ml-auto">
          <select class="form-select" id="displayNumberSelect" bind:value={displayNumber}>
            {#each displayNumbers as displayNumber}
              <option value="{displayNumber}">{displayNumber}</option>
            {/each}
          </select>
          <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>     
        </div>  
      </div>
    </CardFooter>
  </Card>    


<ManageVesselAttributesModal bind:this={manageVesselAttributeModal} on:vesselAttributesUpdated={() => loadVesselsAndAttributes()}></ManageVesselAttributesModal>


<style>
  #displayNumberSelect{
    max-height: 30px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #DEDEDE;
    height:400px;
    color:#3a3a3a;
  }

  .viewButton{
    margin-left: auto;
    padding:10px;   
    font-weight: normal;    
    opacity: 0.8; 
  }  
  .vesselRow{ 
    opacity: 0.8; 
  }
  .vesselRow:hover{
    cursor:pointer; 
    font-weight: 500; 
    opacity: 1; 
    transition: 0.3s ease-in-out;
    color:#414249;
  }

  .toggle{
    cursor: pointer;
  }

</style>